import React from 'react';

import Room from '../room';

import JS1 from './images/junior.1.jpg';
import JS2 from './images/junior.2.jpg';
import JS3 from './images/junior.3.jpg';
import JS4 from './images/junior.4.jpg';
import JS5 from './images/junior.5.jpg';
import JS6 from './images/junior.6.jpg';
const JuniorSuite = () => {

  const images = [
    { original: JS1, thumbnail: JS1 },
    { original: JS2, thumbnail: JS2 },
    { original: JS3, thumbnail: JS3 },
    { original: JS4, thumbnail: JS4 },
    { original: JS5, thumbnail: JS5 },
    { original: JS6, thumbnail: JS6 },
  ]

  return (
    <Room title="Junior Suite" images={images} capacity={4}>
      <p className="p-services">Confortable habitación ubicada en el primer piso de nuestra posada. Cuenta con una pequeña kitchenette para hacer mas cómoda su estadía.</p>
      <p className="p-services">Equipada con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default JuniorSuite;


// WEBPACK FOOTER //
// ./src/rooms/junior-suite/index.js